import React, { useState } from 'react';
import { CustomMode } from './types';
import { PremadeMode } from './premadeModes';
import ModeFormFields from './ModeFormFields';

interface CreateModeFormProps {
    isNameDuplicate: (name: string, excludeName?: string) => boolean;
    onCreate: (modeName: string, mode: CustomMode) => void;
    onCancel: () => void;
    initialMode?: PremadeMode;
}

const CreateModeForm: React.FC<CreateModeFormProps> = ({
    isNameDuplicate,
    onCreate,
    onCancel,
    initialMode
}) => {
    const [modeName, setModeName] = useState(initialMode?.name || '');
    const [newMode, setNewMode] = useState<CustomMode>({
        description: initialMode?.description || '',
        instructions: initialMode?.instructions || '',
        preferredModel: initialMode?.preferredModel || ''
    });

    const handleCreate = () => {
        if (modeName.trim() === '' || newMode.instructions.trim() === '') return;

        if (isNameDuplicate(modeName)) {
            alert('A mode with this name already exists. Please choose a different name.');
            return;
        }

        onCreate(modeName.trim(), {
            description: newMode.description.trim(),
            instructions: newMode.instructions.trim(),
            preferredModel: newMode.preferredModel
        });

        setModeName('');
        setNewMode({ description: '', instructions: '', preferredModel: '' });
    };
    const handleCancel = () => {
        onCancel();
        setModeName('');
        setNewMode({ description: '', instructions: '', preferredModel: '' });
    };

    const isCreateDisabled = !modeName.trim() || !newMode.instructions.trim() || isNameDuplicate(modeName);

    return (
        <div className="bg-neutral-200 dark:bg-neutral-700 p-3 rounded-lg">
            <ModeFormFields
                name={modeName}
                description={newMode.description}
                instructions={newMode.instructions}
                preferredModel={newMode.preferredModel}
                onNameChange={(name) => setModeName(name)}
                onDescriptionChange={(description) => setNewMode({ ...newMode, description })}
                onInstructionsChange={(instructions) => setNewMode({ ...newMode, instructions })}
                onPreferredModelChange={(preferredModel) => setNewMode({ ...newMode, preferredModel })}
            />
            <div className="flex space-x-2">
                <button
                    onClick={handleCreate}
                    disabled={isCreateDisabled}
                    className="bg-cyan-600 hover:bg-cyan-700 text-white px-3 py-1 rounded text-sm disabled:bg-neutral-400 disabled:cursor-not-allowed"
                >
                    Create
                </button>
                <button
                    onClick={handleCancel}
                    className="bg-neutral-500 hover:bg-neutral-600 text-white px-3 py-1 rounded text-sm"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default CreateModeForm;